import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { PARTS_TREE } from '../models/partModel';

export default function CategoriesPage() {
  const navigate = useNavigate();
  const categories = Object.entries(PARTS_TREE);

  const goToRequest = (category, subcategory) =>
    navigate('/request', { state: { category, subcategory } });

  return (
    <div className="min-h-screen bg-gray-50"><Navbar />

      {/* ── HEADER ── */}
      <div className="bg-white border-b border-gray-100 pt-24 pb-8">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="flex items-center gap-2 text-xs text-gray-400 mb-3">
            <button onClick={() => navigate('/')} className="hover:text-blue-700 transition">Ana Sayfa</button>
            <span>›</span><span className="text-gray-600">Kategoriler</span>
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-1">Oto Yedek Parça Kategorileri</h1>
          <p className="text-gray-500 text-sm max-w-3xl">
            OtoParçamıBul, taşıt yedek parçalarını <strong>Ana Kategori → Alt Kategori</strong> hiyerarşisinde
            sınıflandıran çevrimiçi bir parça talep ve teklif platformudur. Aşağıdaki kategorilerden ihtiyacınız
            olan parça grubunu seçerek ücretsiz talep oluşturabilir, onaylı tedarikçilerden teklif alabilirsiniz.
          </p>
          <div className="flex flex-wrap gap-4 mt-4">
            {['✓ Orijinal, Muadil ve Çıkma Parça', '✓ Admin Onaylı Tedarikçiler', '✓ Türkiye Geneli'].map(t => (
              <span key={t} className="text-xs text-gray-500">{t}</span>
            ))}
          </div>
        </div>
      </div>

      {/* ── CATEGORY TREE ── */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
        <div className="grid md:grid-cols-2 gap-6">
          {categories.map(([category, { subcategories }]) => (
            <div key={category} className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
              {/* Ana Kategori */}
              <div className="bg-blue-700 px-5 py-3.5">
                <h2 className="text-white font-bold text-sm">{category}</h2>
                <p className="text-blue-200 text-xs mt-0.5">Ana Kategori</p>
              </div>

              {/* Alt Kategoriler */}
              <div className="p-5 space-y-4">
                {Object.entries(subcategories).map(([subcat, parts]) => (
                  <div key={subcat}>
                    <button
                      onClick={() => goToRequest(category, subcat)}
                      className="text-sm font-semibold text-gray-800 hover:text-blue-700 transition flex items-center gap-1.5 mb-2"
                    >
                      <span className="w-1.5 h-1.5 rounded-full bg-blue-600 flex-shrink-0" />
                      {subcat}
                      <span className="text-xs text-gray-400 font-normal">Alt Kategori</span>
                    </button>
                    <div className="flex flex-wrap gap-1.5 pl-3">
                      {parts.map(part => (
                        <button
                          key={part}
                          onClick={() => goToRequest(category, subcat)}
                          className="text-xs text-gray-600 bg-gray-50 hover:bg-blue-50 hover:text-blue-700 border border-gray-100 rounded-lg px-2.5 py-1 transition"
                        >
                          {part}
                        </button>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-8 bg-blue-700 rounded-2xl p-8 text-center">
          <h3 className="text-white text-xl font-bold mb-2">Aradığınız parça listede yok mu?</h3>
          <p className="text-blue-200 text-sm mb-5 max-w-lg mx-auto">
            Aracınızı ve parçayı belirtin, tedarikçiler size özel teklif göndersin. Kayıt ücretsizdir.
          </p>
          <button onClick={() => navigate('/request')}
            className="bg-white text-blue-700 font-semibold px-6 py-3 rounded-xl text-sm hover:bg-blue-50 transition">
            Ücretsiz Parça Talebi Oluştur →
          </button>
        </div>
      </div>

      <Footer />
    </div>
  );
}
